import { render, staticRenderFns } from "./HomeAplicativo.vue?vue&type=template&id=1d5e44e1&scoped=true&"
import script from "./HomeAplicativo.vue?vue&type=script&lang=js&"
export * from "./HomeAplicativo.vue?vue&type=script&lang=js&"
import style0 from "./HomeAplicativo.vue?vue&type=style&index=0&id=1d5e44e1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5e44e1",
  null
  
)

export default component.exports